export function GetParentElementByClassName(child: HTMLElement, classname: string): any {
  if (child.className.split(' ').indexOf(classname) >= 0) return child;
  try {
    //Throws TypeError if child doesn't have parent any more
    return (
      child.parentElement && GetParentElementByClassName(child.parentElement, classname)
    );
  } catch (TypeError) {
    return false;
  }
}

export function getAbsolutePosition(element: HTMLElement): { x: number; y: number } {
  let el = element;
  let x = 0;
  let y = 0;
  while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
    x += el.offsetLeft - el.scrollLeft;
    y += el.offsetTop - el.scrollTop;
    el = el.offsetParent as HTMLElement;
  }
  return { x, y };
}
